"use client";

import Button from "@/components/Button/Button";
import "./ERPHeroSection.scss";
import ContactFormModal from "@/components/ContactFormModal/ContactFormModal";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { IoPlayCircleOutline } from "react-icons/io5";
import odooLogo from "@/assets/images/logo/odoo-logo.png";
import Image from "next/image";
import customization from "@/assets/icons/services/erp/hero/customization.svg";
import marketing from "@/assets/icons/services/erp/hero/marketing.svg";
import accounting from "@/assets/icons/services/erp/hero/accounting.svg";
import purchase from "@/assets/icons/services/erp/hero/purchase.svg";
import sales from "@/assets/icons/services/erp/hero/sales.svg";

const FLOATING_TAGS = [
  {
    id: 1,
    label: "Customization",
    image: customization,
    bottom: "90%",
    right: "50%",
  },
  {
    id: 2,
    label: "Marketing Automation",
    image: marketing,
    top: "15%",
    left: "60%",
  },
  { id: 3, label: "Sales & CRM", image: sales, top: "70%", right: "70%" },
  {
    id: 4,
    label: "Accounting Finance",
    image: accounting,
    top: "80%",
    left: "65%",
  },
  { id: 5, label: "Purchase", image: purchase, top: "100%", left: "40%" },
];

const ERPHeroSection = ({ hero }) => {
  const router = useRouter();
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleDemoClick = () => {
    router.push("/contact");
  };

  if (!hero) return null;

  const { title, description } = hero;

  return (
    <section className="erp-hero-section">
      <Container className="erp-hero-container">
        <Row className="align-items-center">
          <Col xxl={6} xl={6} lg={6}>
            <div className="hero-left-content">
              <h1>{title}</h1>
              <p>{description}</p>

              <div className="button-container">
                <Button variant="secondary" size="lg" onClick={handleOpenModal}>
                  Get Started Free
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  className="video-btn"
                  onClick={handleDemoClick}
                >
                  Book A Demo
                </Button>
              </div>
            </div>
          </Col>

          <Col xxl={6} xl={6} lg={6}>
            <div className="hero-right">
              <div className="animation-wrapper">
                {/* Animated concentric rings */}
                <div className="ring ring-1"></div>
                <div className="ring ring-2"></div>
                <div className="ring ring-3"></div>
                <div className="ring ring-4"></div>

                {FLOATING_TAGS.map((tag) => (
                  <div
                    key={tag.id}
                    className={`floating-tag floating-tag-${tag.id}`}
                    style={{
                      top: tag.top,
                      bottom: tag.bottom,
                      left: tag.left,
                      right: tag.right,
                      animationDelay: `${tag.id * 0.4}s`,
                    }}
                  >
                    <div className="tag-img">
                      <Image
                        src={tag.image}
                        alt={tag.label}
                        width={28}
                        height={28}
                      />
                    </div>
                    <span className="tag-label">{tag.label}</span>
                  </div>
                ))}

                {/* Odoo logo center */}
                <div className="odoo-logo-wrapper">
                  <Image
                    src={odooLogo}
                    alt="odoo-logo"
                    className="odoo-logo"
                    width={170}
                    height={60}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <ContactFormModal
        show={showModal}
        onClose={handleCloseModal}
        onConfirm={handleCloseModal}
      />
    </section>
  );
};

export default ERPHeroSection;
